import template from './create-definition-paywall.html';
import { getSupportEmail } from '@mode/shared/util-js';

export default class CreateDefinitionPaywallModalController {
  // TODO: Delete this controller when the WorkspaceRename flag is removed
  readonly intercomEmail = getSupportEmail();
  workspaceTitle: string;
}
export const CreateDefinitionPaywallModalComponent: angular.IComponentOptions = {
  controller: CreateDefinitionPaywallModalController,
  controllerAs: 'ctrl',
  template,
  bindings: {
    intercomEmail: '<',
  },
};
